var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuleTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 4.1875H3.50048C2.75248 4.1875 2.00048 4.5 2.00048 5.5V18.3633C1.98047 19.2773 2.55328 19.8125 3.50048 19.8125H20.5345C21.4278 19.8125 22.0005 19.3371 22.0005 18.4645V5.48438C22.0005 4.75391 21.5391 4.1875 20.625 4.1875ZM7.70361 18.25H3.56298V9.26562H7.70361V18.25ZM20.438 18.25H9.26611V9.26562H20.438V18.25ZM20.438 7.70312H3.56298V5.75H20.438V7.70312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleTable);
export default __webpack_public_path__ + "static/media/rule-table.93b6ac84decf80ec4d891245adf1f2af.svg";
export { ForwardRef as ReactComponent };